import { GroupBase, OptionProps, SingleValueProps } from "react-select";
import { components } from "react-select";

import { Select, SelectProps } from "@ui/Select";
import { ICompanyPriority } from "@interfaces/company.interface";

export interface IPrioritySelectOption extends ICompanyPriority {
  value: string;
  label: string;
}

export function PrioritySelect<OptionType extends IPrioritySelectOption>({
  ...rest
}: SelectProps<OptionType, false>) {
  const CustomOption = (
    props: JSX.IntrinsicAttributes & OptionProps<OptionType, false, GroupBase<OptionType>>
  ) => {
    return (
      <components.Option {...props}>
        <div className="flex items-center gap-1 font-medium">
          <div
            className="flex h-5 w-5 items-center justify-center"
            dangerouslySetInnerHTML={{ __html: props.data.icon || "" }}
          />
          {props.label}
        </div>
      </components.Option>
    );
  };

  const SingleValue = (props: SingleValueProps<OptionType, false>) => {
    return (
      <components.SingleValue {...props}>
        <div className="flex items-center gap-1">
          {props.data.icon && (
            <span
              dangerouslySetInnerHTML={{ __html: props.data.icon }}
              style={{ display: "inline-flex" }}
            />
          )}
          <span className="inline-block text-overflow-ellipsis">{props.data.label}</span>
        </div>
      </components.SingleValue>
    );
  };

  return (
    <Select<OptionType, false>
      {...rest}
      isMulti={false}
      isSearchable={false}
      menuPosition="absolute"
      components={{ Option: CustomOption, SingleValue, ...(rest.components || {}) }}
    />
  );
}
